import React from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';
import ProgressSteps from '../components/progress-steps';
import { Button, CheckboxTable, DatePicker, FallbackImage, Input, PaperClip, Select, Textarea } from 'components';
import { Constants, Globals } from 'utils';
import { AddIcon, ArrowLeft, DeleteIcon, TimeIcon } from 'assets/icons';
import { WhiteImage } from 'assets/img';
import { MODAL, STEP, useForm } from '../business/use-form';
import { CheckboxRow, PassInput, } from '../components';
import TermsModal from '../components/terms-modal';

const initialProduct = {
  name: '',
  image: '',
  image_blob: '',
};

const RegisterClinic = () => {
  const { form, getCities, modal, nextStep, onChange, onChangeValue, prevStep, selects, setModal, step } = useForm();

  return (
    <div id="register-affiliate">
      <TermsModal
        visible={modal === MODAL.TERMS}
        onClose={() => setModal(MODAL.NONE)}
        level_id={Constants.AFFILIATE_TYPES.BUSINESS_SERVICE_OR_ADVERTISER}
      />
      <Link className="back-btn" to="/register/select-level">
        <img src={ArrowLeft} alt="Back" />
      </Link>

      <TermsModal
        level_id={Constants.LEVELS.AFFILIATE}
        visible={modal === MODAL.TERMS}
        onClose={() => setModal(MODAL.NONE)}
      />

      <main>
        <h4>Registro</h4>
        <ProgressSteps activeIndex={step} total={Object.keys(STEP).length} />

        <div className="content">
          {step === STEP.STEP1 && (
            <>
              <section>
                <h5>Datos de la empresa</h5>
                <div className="grid-2 mb-3">
                  <Input
                    className="mb-3 col-span-2"
                    label="Nombre de la empresa"
                    placeholder="Nombre de la empresa"
                    name="name"
                    value={form.name}
                    onChange={onChange}
                  />

                  <div className="container-select">
                    <label>Documento</label>
                    <div>
                      <Select
                        name="document_type_id"
                        value={form.document_type_id}
                        options={selects.document_types}
                        onChange={onChange}
                      />
                      <Input
                        type="number"
                        placeholder="Documento"
                        name="document"
                        value={form.document}
                        onChange={onChange} />
                    </div>
                  </div>
                  <div className="container-select">
                    <label>Teléfono</label>
                    <div>
                      <Select
                        name="phonecode_id"
                        value={form.phonecode_id}
                        options={selects.phonecodes}
                        onChange={onChange}
                      />
                      <Input
                        type="number"
                        placeholder="Teléfono"
                        name="phone"
                        value={form.phone}
                        onChange={onChange}
                      />
                    </div>
                  </div>

                  <DatePicker
                    label="Fecha de fundado"
                    dateFormat="dd-MM-yyyy"
                    showYearDropdown={true}
                    maxDate={moment().toDate()}
                    minDate={moment('1900-01-01').toDate()}
                    value={form?.birthdate ? moment(form.birthdate).toDate() : null}
                    onChange={(v: Date) => onChangeValue('birthdate', moment(v).format('YYYY-MM-DD'))}
                  />
                  <Input
                    className="mb-3"
                    label="Correo"
                    placeholder="Correo"
                    name="email"
                    value={form.email}
                    onChange={onChange}
                  />

                  <Select
                    label="Estado"
                    name="state_id"
                    value={form.state_id}
                    options={selects.states}
                    onChange={(e: any) => {
                      onChange(e);
                      onChangeValue('city_id', '');
                      getCities();
                    }}
                  />
                  <Select
                    label="Ciudad"
                    name="city_id"
                    value={form.city_id}
                    options={selects.cities}
                    onChange={onChange}
                  />
                </div>

                <Textarea
                  label="Dirección"
                  placeholder="Dirección"
                  rows={3}
                  name="address"
                  value={form.address}
                  onChange={onChange}
                />
              </section>

              <br />

              <section>
                <h5>Datos de la persona de contacto</h5>

                <div className="grid-2">
                  <Input
                    label="Nombre"
                    placeholder="Nombre"
                    name="contact_person_name"
                    value={form.contact_person_name}
                    onChange={onChange}
                  />

                  <div className="container-select">
                    <label>Documento</label>
                    <div>
                      <Select
                        name="contact_person_doc_type_id"
                        value={form.contact_person_doc_type_id}
                        options={selects.document_types}
                        onChange={onChange}
                      />
                      <Input
                        type="number"
                        placeholder="Documento"
                        name="contact_person_document"
                        value={form.contact_person_document}
                        onChange={onChange} />
                    </div>
                  </div>
                  <div className="container-select">
                    <label>Teléfono</label>
                    <div>
                      <Select
                        name="contact_person_phone_code_id"
                        value={form.contact_person_phone_code_id}
                        options={selects.phonecodes}
                        onChange={onChange}
                      />
                      <Input
                        type="number"
                        placeholder="Teléfono"
                        name="contact_person_phone"
                        value={form.contact_person_phone}
                        onChange={onChange}
                      />
                    </div>
                  </div>

                  <Input
                    className="mb-3"
                    label="Correo"
                    placeholder="Correo"
                    name="contact_person_email"
                    value={form.contact_person_email}
                    onChange={onChange}
                  />
                </div>
              </section>

              <br />

              <section>
                <h5>Contraseña</h5>
                <p>Su contraseña debe tener un mínimo de 8 caracteres</p>

                <div className="grid-2">
                  <PassInput
                    label="Contraseña"
                    name="password"
                    onChange={onChange}
                  />
                  <PassInput
                    label="Repetir contraseña"
                    name="password_confirmation"
                    onChange={onChange}
                  />
                </div>

                <div className="terms">
                  <CheckboxTable
                    active={Boolean(form.terms)}
                    onClick={() => onChangeValue('terms', !form.terms)}
                  />
                  <span>
                    <span>Acepto los </span>
                    <span className="highlight" onClick={() => setModal(MODAL.TERMS)}>
                      Términos y condiciones y la política de privacidad
                    </span>
                  </span>
                </div>
              </section>
            </>
          )}

          {step === STEP.STEP2 && (
            <section>
              <h5>Datos sobre el servicio</h5>

              <div className="d-flex align-items-center">
                <p className="label mr-4">Categorías</p>
                <div className="btn-add-mini" onClick={() => setModal(MODAL.CATEGORY)}>
                  <img src={AddIcon} alt="Agregar" />
                  <span>Agregar</span>
                </div>
                {modal === MODAL.CATEGORY && (
                  <div className="select-mb-0 ml-3">
                    <Select
                      className="speciality_select mb-0"
                      name="category_id"
                      value={form.category_id}
                      options={selects.categories?.filter((i: any) =>
                        !form.categories?.includes(i.value) && i.label !== 'Clasificados'
                      )}
                      onChange={e => {
                        const data = form?.categories?.includes(e.target.value)
                          ? form?.categories?.filter(i => i !== e.target.value)
                          : form?.categories?.concat([e.target.value]);
                        onChangeValue('categories', data);
                        setModal(MODAL.NONE);
                      }}
                    />
                  </div>
                )}
              </div>

              <div className="mb-4 speciality-list">
                {form.categories?.map((id: any, index: number) => (
                  <span
                    key={index}
                    onClick={() => {
                      const data = form.categories?.filter((item: string) => item !== id);
                      onChangeValue('categories', data);
                    }}
                  >
                    {String(selects.categories.find((i: any) => i.value === id)?.label)}
                  </span>
                ))}
              </div>

              <h6>Horario de atención</h6>

              <div className="grid-3">
                <DatePicker
                  label="Desde"
                  showTimeSelect={true}
                  showTimeSelectOnly={true}
                  timeCaption="Hora"
                  calendarIcon={TimeIcon}
                  dateFormat="h:mm aa"
                  value={form?.consultation?.init_hour ? moment(form.consultation.init_hour, 'HH:mm:ss').toDate() : null}
                  onChange={(v: Date) => onChangeValue('consultation', { ...form.consultation, init_hour: moment(v).format('HH:mm:ss') })}
                />
                <DatePicker
                  label="Hasta"
                  showTimeSelect={true}
                  showTimeSelectOnly={true}
                  timeCaption="Hora"
                  calendarIcon={TimeIcon}
                  dateFormat="h:mm aa"
                  value={form?.consultation?.end_hour ? moment(form.consultation.end_hour, 'HH:mm:ss').toDate() : null}
                  onChange={(v: Date) => onChangeValue('consultation', { ...form.consultation, end_hour: moment(v).format('HH:mm:ss') })}
                />
              </div>

              <br />

              <p className="label">Días</p>
              <div className="days">
                {selects.weekDays.map((weekday, wIdx) => {
                  const isSelected = form?.consultation?.days?.includes(weekday.value);
                  return (
                    <div
                      key={wIdx}
                      className="day"
                      data-selected={String(isSelected)}
                      onClick={() => {
                        const data = isSelected
                          ? form?.consultation?.days?.filter(i => i !== weekday.value)
                          : form?.consultation?.days?.concat([weekday.value]);
                        onChangeValue('consultation', { ...form.consultation, days: data });
                      }}
                    >
                      {weekday.label}
                    </div>
                  )
                })}
              </div>

              <br />

              <div className="grid-3">
                <div
                  className="check-item"
                  onClick={() => onChangeValue('consultation', { ...form.consultation, home_service: !form.consultation.home_service })}
                >
                  <CheckboxTable active={!!form?.consultation.home_service} />
                  <p>Disponible para consultas a domicilio</p>
                </div>

                <div
                  className="check-item"
                  onClick={() => onChangeValue('consultation', { ...form.consultation, delivery_service: !form.consultation.delivery_service })}
                >
                  <CheckboxTable active={!!form?.consultation.delivery_service} />
                  <p>Cuenta con servicio de delivery</p>
                </div>
              </div>

              <br />

              <div>
                <label className="contact-method-title">Método de contacto</label>
                <div className="contact-method-list">
                  {selects.contact_methods.map((cm, cmIdx) => {
                    const isSelected = form.consultation.contact_methods.includes(cm.value);
                    return (
                      <div
                        key={cmIdx}
                        className="contact-method"
                        data-selected={String(isSelected)}
                        onClick={() => {
                          const data = isSelected
                            ? form?.consultation?.contact_methods?.filter(i => i !== cm.value)
                            : form?.consultation?.contact_methods?.concat([cm.value]);
                          onChangeValue('consultation', { ...form.consultation, contact_methods: data });
                        }}
                      >
                        <img src={cm.icon} alt="Método de contacto" />
                        <span>{cm.label}</span>
                      </div>
                    )
                  })}
                </div>
              </div>
            </section>
          )}

          {step === STEP.STEP3 && (
            <section>
              <h5>Productos</h5>
              <div className="d-flex align-items-center justify-content-between">
                <p>¿Vendes algún producto? (Opcional)</p>

                <div className="btn-add-mini mb-3" onClick={() => onChangeValue('products', form.products.concat([Globals.clone(initialProduct)]))}>
                  <img src={AddIcon} alt="Agregar" />
                  <span>Agregar</span>
                </div>
              </div>

              <div className="products">
                {form?.products?.map((i: any, index: number) => (
                  <div key={index} className="product">
                    <label className="product-wrapper">
                      <FallbackImage
                        src={i?.image_blob}
                        placeholder={WhiteImage}
                        className="product-image"
                        placeholderClassName="product-image"
                      />
                      <input
                        type="file"
                        accept="image/*"
                        hidden
                        onChange={e => {
                          const file = e.target.files?.[0];
                          if (!file) return;
                          const data = form.products.map((i: any, idx: number) => (
                            idx === index ? { ...i, image: file, image_blob: URL.createObjectURL(file) } : i
                          ));
                          onChangeValue('products', data);
                        }}
                      />
                    </label>
                    <Input
                      color="white name"
                      name="name"
                      placeholder="Nuevo producto"
                      value={i.name}
                      onChange={e => {
                        const data = form.products.map((i: any, idx: number) => (
                          idx === index ? { ...i, name: e.target.value } : i
                        ));
                        onChangeValue('products', data)
                      }}
                    />
                    <div className="remove">
                      <img
                        src={DeleteIcon}
                        alt="Producto"
                        onClick={() => {
                          const data = form.products.filter((_, idx: number) => idx !== index);
                          onChangeValue('products', data);
                        }}
                      />
                    </div>
                  </div>
                ))}
              </div>
            </section>
          )}

          {step === STEP.STEP4 && (
            <>
              <section>
                <h5>Información adicional</h5>

                <br />

                <div className="grid-3">
                  <div className="container-image">
                    <PaperClip
                      className="paperclip-image"
                      value={form.photo}
                      onChange={(e: any) => {
                        onChangeValue('photo', e.target);
                        onChangeValue('photo_blob', URL.createObjectURL(e.target.value));
                      }}
                    >
                      <FallbackImage
                        src={form.photo?.dataURL || form.photo_blob}
                        placeholder={WhiteImage}
                        className="selected-image"
                        placeholderClassName="selected-image inactive"
                        alt="Logo"
                      />
                    </PaperClip>
                    <p className="photo-title">Imagen publicitaria</p>
                  </div>

                  <div className="col-span-2">
                    <Textarea
                      label="Descripción de su empresa"
                      placeholder="Indique brevemente"
                      rows={3}
                      color="white"
                      name="description"
                      value={form.description}
                      onChange={onChange}
                    />
                  </div>
                </div>
              </section>

              <section>
                <h5 className="d-flex">Aceptación de<span
                  className="blue pl-1"
                  onClick={() => setModal(MODAL.TERMS)}
                  style={{ cursor: 'pointer' }}
                >
                  <b>Términos y Condiciones</b>
                </span></h5>
                <CheckboxRow
                  label="Declaro que toda la información proporcionada por mí, es veraz y completa."
                  checked={!!form.terms_truth}
                  onToggle={() => onChangeValue('terms_truth', !form.terms_truth)}
                />
                <CheckboxRow
                  label="Autorizo a iZoo a verificar toda la información suministrada ante las instituciones correspondientes."
                  checked={!!form.terms_verify}
                  onToggle={() => onChangeValue('terms_verify', !form.terms_verify)}
                />
                <CheckboxRow
                  label="Me comprometo a cumplir las leyes nacionales y las normas establecidas por iZoo App."
                  checked={!!form.terms_law}
                  onToggle={() => onChangeValue('terms_law', !form.terms_law)}
                />
              </section>
            </>
          )}

          <div className="actions">
            {step > STEP.STEP1 && (
              <Button onClick={prevStep}>
                Anterior
              </Button>
            )}
            <Button onClick={nextStep}>
              {step === STEP.STEP4 ? 'GUARDAR' : 'Siguiente'}
            </Button>
          </div>
        </div>
      </main>
    </div>
  )
}

export default RegisterClinic